function shopLocale(state = {}, action) {
	switch (action.type) {
		case 'GET_SHOP_LOCALE_LIST_SUCCESS': {
			return action.payload;
		}
		case 'ADD_SHOP_LOCALE_LIST_SUCCESS': {
			return {
				...state,
				data: [
					{ ...action.payload, productLocales: [] },
					...state.data
				]
			};
		}
		case 'EDIT_SHOP_LOCALE_LIST_SUCCESS': {
			const locales = state.data;
			const editLocaleIdx = locales.findIndex(el => {
				return el.id === action.payload.id;
			});
			if (editLocaleIdx >= 0) {
				locales[editLocaleIdx] = {
					...action.payload,
					productLocales: locales[editLocaleIdx].productLocales
				};
			}
			return {
				...state,
				data: locales
			};
		}
		default:
			return state;
	}
}

export default shopLocale;



// WEBPACK FOOTER //
// ./routes/app/routes/shop-locale/reducer/index.js